import { Box, Text, Flex, Image } from "@chakra-ui/react";
import AddIcon from "./assets/add.png";
import GoIcon from "./assets/go.png";
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "@/context/UserInfo";

const AddBank = ({ onAddAccountOpen }: { onAddAccountOpen: () => void }) => {
  const navigate = useNavigate();
  const { bridgeCustomer } = useUserInfo();
  return (
    <Flex
      onClick={() => {
        onAddAccountOpen();
      }}
      sx={{
        width: "100%",
        height: "170px",
        background: "#D8762B",
        borderRadius: "10px",
        overflow: "hidden",
        paddingTop: "16px",
      }}
      flexDir={"column"}
      align={"center"}
    >
      <Text
        sx={{
          color: "#D8762B",
          textAlign: "center",
          fontFamily: "DIN-Black",
          fontSize: "14px",
          fontWeight: 900,
        }}
      >
        Bank Account
      </Text>
      <Image
        src={AddIcon}
        sx={{
          width: "28px",
          marginTop: "20px",
        }}
      ></Image>{" "}
      <Text
        sx={{
          color: "#fff",
          textAlign: "center",
          fontFamily: "DIN-Black",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: 900,
          marginTop: "12px",
        }}
      >
        Add Account{" "}
      </Text>
      <Text
        sx={{
          color: "#FFF",
          textAlign: "center",
          fontFamily: "DIN",
          fontSize: "14px",
          fontWeight: 700,
          marginTop: "10px",
        }}
      >
        You can add a new bank account
      </Text>
    </Flex>
  );
};

export default AddBank;
